import { LOCALES } from "constants/locales"

export const getBaseUrl = () => {
  switch (process.env.LOCALE) {
    case LOCALES.KO:
      return "oneulook.com"
    case LOCALES.JA:
      return "kyolook.com"
  }
}

const BASE = {
  URL: getBaseUrl(),
}

const AWS = {
  S3: "https://nmodelin20.s3.ap-northeast-2.amazonaws.com",
}

const DOMAIN = {
  BASE,
  AWS,
}

export default DOMAIN
